const fileSchema = {
  id: '/File',
  type: 'object',
  properties: {
    fileId: { type: 'string' },
    originalName: { type: 'string' },
    storageName: { type: 'string' },
    checksum: { type: 'string' },
    publicFileURI: { type: 'string' },
    repositoryId: { type: 'integer', minimum: 1 },
  },
  required: ['fileId', 'originalName', 'storageName', 'checksum', 'publicFileURI', 'repositoryId'],
};

// TODO: despues de que me defina diego armar el schema bien
// const boxTargetSchema = {
//   id: '/BoxTarget',
//   type: 'object',
//   properties: {},
//   required: [],
// };

const boxTargetSchema = { type: 'string' };

const dateSchema = { type: 'date' };

const detailSchema = {
  id: '/Detail',
  type: 'object',
  properties: {},
  required: [],
};

const locationSchema = {
  id: '/Location',
  type: 'object',
  properties: {
    type: { type: 'string' },
    geometry: {
      type: 'object',
      properties: {
        type: { type: 'string' },
        coordinates: { type: 'array', items: { type: 'float' } },
      },
      required: ['type', 'coordinates'],
    },
    properties: {
      type: 'object',
      properties: {
        center: {
          type: 'object',
          properties: {
            lat: { type: 'float' },
            lng: { type: 'float' },
          },
          required: ['lat', 'lng'],
        },
        required: ['center'],
      },
    },
  },
  required: ['type', 'geometry', 'properties'],
};

const maskedSchema = { type: 'string' };
const multiSelectSchema = {};
const nftLinkSChema = {};
const numberSchema = { type: 'integer' };

const polygonSchema = {
  id: '/Polygon',
  type: 'object',
  properties: {
    type: { type: 'string' },
    geometry: {
      type: 'object',
      properties: {
        type: { type: 'string' },
        coordinates: { type: 'array', items: { type: 'float' } },
      },
      required: ['type', 'coordinates'],
    },
    properties: {
      type: 'object',
      properties: {
        center: {
          type: 'object',
          properties: {
            lat: { type: 'float' },
            lng: { type: 'float' },
          },
          required: ['lat', 'lng'],
        },
        required: ['center'],
      },
    },
  },
  required: ['type', 'geometry', 'properties'],
};

const selectImageSchema = {
  id: '/SelectImage',
  type: 'object',
  properties: {},
  required: [],
};

const selectSchema = { type: 'string' };

const stringSchema = { type: 'string' };

module.exports = {
  fileSchema,
  boxTargetSchema,
  dateSchema,
  detailSchema,
  locationSchema,
  maskedSchema,
  multiSelectSchema,
  nftLinkSChema,
  numberSchema,
  polygonSchema,
  selectImageSchema,
  selectSchema,
  stringSchema,
};
